@if (isAuthenticated | async) {
  <ul class="navbar-nav">
    <li class="nav-item d-flex align-items-center py-2 px-3">
      <select
        class="form-select form-select-sm"
        [(ngModel)]="languageService.currentLanguage"
        [ngModelOptions]="{ standalone: true }"
        (change)="setLanguage($event)"
      >
        @for (language of languages; track language.value) {
          <option value="{{ language.value }}">{{ language.text }}</option>
        }
      </select>
    </li>
  </ul>
}
